export default "__VITE_ASSET__079be2ba__"